<template>
  <span class="Faded"><slot></slot></span>
</template>

<script>
export default {
  name: "Faded"
};
</script>

<style scoped>
.Faded {
  opacity: 0.5;
}
</style>
